import styled from 'styled-components';

export const LogoCoverStyled = styled(`div`)`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 12px;
	height: 282px;
	background-size: cover;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 508px;
		height: 508px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 162px;
		height: 162px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 205px;
		height: 205px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 282px;
		height: 282px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 282px;
		height: 282px;
	}
`;
